import { Grid, Stack, Typography } from "@mui/material";
import { CustomDetailsList, Loader } from "../../../shared";
import { useChartSettings } from "../hooks";
import emptyIcon from "../../../assets/images/Icons/search-table.png";

export const ChartSettingsView = ({ recipeId }) => {
  const { chartSettingsQuery } = useChartSettings({ recipeId });

  if (chartSettingsQuery.isLoading) {
    return <Loader />;
  }

  const bmscData = {
    front_roller_setting_no: chartSettingsQuery.data.front_roller_setting_no,
    bread_moulder_settings_chart:
      chartSettingsQuery.data.bread_moulder_setting_chart,
  };

  const bmscColumns = [
    bmscData?.front_roller_setting_no
      ? {
          title: "Front Roller Setting No",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.front_roller_setting_no}
              </Typography>
            );
          },
        }
      : null,
    bmscData?.bread_moulder_settings_chart
      ? {
          title: "Back Roller Setting No",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.bread_moulder_settings_chart}
              </Typography>
            );
          },
        }
      : null,
  ].filter(Boolean);

  const ottcData = {
    baking_time_min_full_decks: chartSettingsQuery.data.baking_time,
    temperature: chartSettingsQuery.data.temperature,
    steaming_shots: chartSettingsQuery.data.steaming_shots,
    cut: chartSettingsQuery.data.cut,
    decorate: chartSettingsQuery.data.decorate,
    other_settings: (
      <Grid container>
        <Grid item xs={6}>
          Top:{chartSettingsQuery.data.oven_temperature_top}
        </Grid>
        <Grid item xs={6}>
          Bottom:{chartSettingsQuery.data.oven_temperature_bottom}
        </Grid>
      </Grid>
    ),
  };

  const ottcColumns = [
    ottcData?.baking_time_min_full_decks
      ? {
          title: "Baking Time(min) - Full Decks",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.baking_time_min_full_decks}
              </Typography>
            );
          },
        }
      : null,
    ottcData?.temperature
      ? {
          title: "Temperature (°C)",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.temperature}
              </Typography>
            );
          },
        }
      : null,
    ottcData?.steaming_shots
      ? {
          title: "Steam",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.steaming_shots}
              </Typography>
            );
          },
        }
      : null,
    ottcData?.cut
      ? {
          title: "Cut",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.cut}
              </Typography>
            );
          },
        }
      : null,
    ottcData?.decorate
      ? {
          title: "Decorate",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.decorate}
              </Typography>
            );
          },
        }
      : null,
    ottcData.other_settings.props.children[0].props.children[1] ||
    ottcData.other_settings.props.children[1].props.children[1]
      ? {
          title: "Shelf",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.other_settings}
              </Typography>
            );
          },
        }
      : null,
  ].filter(Boolean);
  const freezData = (before_baking, after_baking) => {
    let freeze = "";
    if (before_baking === 1) freeze = "Before baking";
    if (after_baking) {
      if (freeze !== "") {
        freeze += ", After baking";
      } else {
        freeze += "After baking";
      }
    }
    return freeze;
  };
  const ottcData1 = {
    time_period: chartSettingsQuery.data.time_period,
    freeze: freezData(
      chartSettingsQuery.data.before_baking,
      chartSettingsQuery.data.after_baking
    ),
    primary_or_secondary: chartSettingsQuery.data.primary
      ? "Primary"
      : "Secondary",
    mandatoy_or_optional: chartSettingsQuery.data.mandatory
      ? "Mandatory"
      : "Optional",
  };
  const ottcColumns1 = [
    ottcData1?.time_period
      ? {
          title: "Time Period",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.time_period}
              </Typography>
            );
          },
        }
      : null,
    ottcData1?.freeze
      ? {
          title: "Freeze",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.freeze}
              </Typography>
            );
          },
        }
      : null,

    ottcData1?.primary_or_secondary
      ? {
          title: "Primary or Secondary",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.primary_or_secondary}
              </Typography>
            );
          },
        }
      : null,
    ottcData1?.mandatoy_or_optional
      ? {
          title: "Mandatory or Optional",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.mandatoy_or_optional}
              </Typography>
            );
          },
        }
      : null,
  ].filter(Boolean);
  const rmscData = {
    settings_no: chartSettingsQuery.data.roll_moulder_setting_no,
    rounding_time: chartSettingsQuery.data.roll_moulder_rounding_time,
  };
  const rmscColumns = [
    rmscData?.settings_no
      ? {
          title: "Settings No",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.settings_no}
              </Typography>
            );
          },
        }
      : null,

    rmscData?.rounding_time
      ? {
          title: "Rounding Time",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.rounding_time}
              </Typography>
            );
          },
        }
      : null,
  ].filter(Boolean);

  const ptcData = {
    proving_time: chartSettingsQuery.data.proving_time,
  };

  const ptcColumns = [
    ptcData?.proving_time
      ? {
          title: "Proving Time",
          accessor: "proving_time",
        }
      : null,
  ];
  const pssData = {
    pastry_sheeter_setting_no:
      chartSettingsQuery.data.pastry_sheeter_setting_no,
    pastry_sheeter_amount_of_turns:
      chartSettingsQuery.data.pastry_sheeter_amount_of_turns,
    time_through_pastry_sheeter_final_settings:
      chartSettingsQuery.data.time_through_pastry_sheeter_final_settings,
    pastry_sheeter_bottom_weight:
      chartSettingsQuery.data.pastry_sheeter_bottom_weight,
    pastry_sheeter_top_weight:
      chartSettingsQuery.data.pastry_sheeter_top_weight,
    pastry_sheeter_filling_weight:
      chartSettingsQuery.data.pastry_sheeter_filling_weight,
    pastry_sheeter_unbacked_weight:
      chartSettingsQuery.data.pastry_sheeter_unbacked_weight,
  };

  const inductionData = {
    initial_watts: chartSettingsQuery.data.initial_watts,
    initial_time: chartSettingsQuery.data.initial_time_text,
    initial_description: chartSettingsQuery.data.initial_description,
    increased_watts: chartSettingsQuery.data.increased_watts,
    increased_time: chartSettingsQuery.data.increased_time_text,
    increased_description: chartSettingsQuery.data.increased_description,
  };
  const pssColumns = [
    pssData?.pastry_sheeter_setting_no
      ? {
          title: "Sheeter Setting No",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.pastry_sheeter_setting_no}
              </Typography>
            );
          },
        }
      : null,

    pssData?.pastry_sheeter_amount_of_turns
      ? {
          title: "Amount Of turns",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.pastry_sheeter_amount_of_turns}
              </Typography>
            );
          },
        }
      : null,

    pssData?.time_through_pastry_sheeter_final_settings
      ? {
          title: "Time through sheeter at final settings",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.time_through_pastry_sheeter_final_settings}
              </Typography>
            );
          },
        }
      : null,

    pssData?.pastry_sheeter_bottom_weight
      ? {
          title: "Bottom Weight",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.pastry_sheeter_bottom_weight}
              </Typography>
            );
          },
        }
      : null,

    pssData?.pastry_sheeter_top_weight
      ? {
          title: "Mandatoy or OptionalTop Weight",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.pastry_sheeter_top_weight}
              </Typography>
            );
          },
        }
      : null,

    pssData?.pastry_sheeter_filling_weight
      ? {
          title: "Filling Weight",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.pastry_sheeter_filling_weight}
              </Typography>
            );
          },
        }
      : null,

    pssData?.pastry_sheeter_unbacked_weight
      ? {
          title: "Unbaked Weight",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.pastry_sheeter_unbacked_weight}
              </Typography>
            );
          },
        }
      : null,
  ].filter(Boolean);

  const inductionCookerColumns = [
    inductionData?.initial_watts
      ? {
          title: "Initial Watts",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.initial_watts}
              </Typography>
            );
          },
        }
      : null,

    inductionData?.initial_time
      ? {
          title: "Time",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.initial_time}
              </Typography>
            );
          },
        }
      : null,

    inductionData?.initial_description
      ? {
          title: "Description",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.initial_description}
              </Typography>
            );
          },
        }
      : null,

    inductionData?.increased_watts
      ? {
          title: "Increased Watts",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.increased_watts}
              </Typography>
            );
          },
        }
      : null,

    inductionData?.increased_time
      ? {
          title: "Time",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.increased_time}
              </Typography>
            );
          },
        }
      : null,

    inductionData?.increased_description
      ? {
          title: "Description",
          accessor: (val) => {
            return (
              <Typography variant="subtitle2" fontWeight={500}>
                {val.increased_description}
              </Typography>
            );
          },
        }
      : null,
  ].filter(Boolean);
  const isEmpty =
    chartSettingsQuery.data.bread_moulder_enabled ||
    chartSettingsQuery.data.proving_time_enabled ||
    chartSettingsQuery.data.oven_time_temp_enabled ||
    chartSettingsQuery.data.production_wastage_enabled ||
    chartSettingsQuery.data.roll_moulder_enabled ||
    chartSettingsQuery.data.pastry_sheeter_enabled ||
    chartSettingsQuery.data.induction_cooker_status;

  return (
    <>
      {isEmpty ? (
        <Stack>
          {chartSettingsQuery.data.bread_moulder_enabled &&
          (bmscData?.bread_moulder_settings_chart ||
            bmscData?.front_roller_setting_no) ? (
            <CustomDetailsList
              columns={bmscColumns}
              data={bmscData}
              title="Bread Moulder Settings Chart"
            />
          ) : (
            <></>
          )}
          {chartSettingsQuery.data.proving_time_enabled &&
          ptcData.proving_time ? (
            <CustomDetailsList
              columns={ptcColumns}
              data={ptcData}
              title="Proving Time Chart"
            />
          ) : (
            <></>
          )}
          {chartSettingsQuery.data.oven_time_temp_enabled &&
          (ottcData.baking_time_min_full_decks ||
            ottcData.temperature ||
            ottcData.steaming_shots ||
            ottcData.cut ||
            ottcData.decorate ||
            ottcData.other_settings) ? (
            <CustomDetailsList
              columns={ottcColumns}
              data={ottcData}
              title="Oven Time & Temperature Chart"
            />
          ) : (
            <></>
          )}
          {chartSettingsQuery.data.production_wastage_enabled &&
          (ottcData1.mandatoy_or_optional ||
            ottcData1.primary_or_secondary ||
            ottcData1.freeze ||
            ottcData1.time_period) ? (
            <CustomDetailsList
              columns={ottcColumns1}
              data={ottcData1}
              title="Production & Wastage sheet"
            />
          ) : (
            <></>
          )}
          {chartSettingsQuery.data.roll_moulder_enabled &&
          (rmscData.rounding_time || rmscData.settings_no) ? (
            <CustomDetailsList
              columns={rmscColumns}
              data={rmscData}
              title="Roll Moulder Settings Chart"
            />
          ) : (
            <></>
          )}
          {chartSettingsQuery.data.pastry_sheeter_enabled &&
          (pssData.pastry_sheeter_amount_of_turns ||
            pssData.pastry_sheeter_bottom_weight ||
            pssData.pastry_sheeter_filling_weight ||
            pssData.pastry_sheeter_setting_no ||
            pssData.pastry_sheeter_top_weight ||
            pssData.pastry_sheeter_unbacked_weight ||
            pssData.time_through_pastry_sheeter_final_settings) ? (
            <CustomDetailsList
              columns={pssColumns}
              data={pssData}
              title="Pastry Sheeter Settings Chart"
            />
          ) : (
            <></>
          )}
          {chartSettingsQuery.data.induction_cooker_status &&
          (inductionData.initial_watts ||
            inductionData.initial_time ||
            inductionData.initial_description ||
            inductionData.increased_watts ||
            inductionData.increased_time ||
            inductionData.increased_description) ? (
            <CustomDetailsList
              columns={inductionCookerColumns}
              data={inductionData}
              title="Induction Cooker"
            />
          ) : (
            <></>
          )}
        </Stack>
      ) : (
        <Stack alignItems="center" gap="8px" mt={20}>
          <img src={emptyIcon} alt="empty" height={56} width={56} />
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "14px",
              color: "#485364",
            }}
          >
            No settings added yet!.
          </Typography>
        </Stack>
      )}
    </>
  );
};
